import { interpolateCdiAge } from '../../shared/institutionalAge.js';

export const HERO_FALLBACK_BADGE = 'Há {{idade_cdi}} anos em Goiânia';
export const DEFAULT_HERO_SLIDE_DURATION_SECONDS = 6;

// Monta a URL do catálogo de exames com o termo de busca codificado. Termos
// vazios retornam a rota base sem query string.
export function heroExamSearchHref(examsPath, term) {
  const trimmed = String(term || '').trim();
  if (!trimmed) return examsPath;
  return `${examsPath}?q=${encodeURIComponent(trimmed)}`;
}

// Interpreta um gesto de toque horizontal. Retorna 'next' ou 'prev' quando o
// movimento horizontal domina e supera o limiar; null para verticais, curtos
// ou inválidos.
export function resolveHeroSwipe(startX, startY, endX, endY, { threshold = 48 } = {}) {
  const values = [startX, startY, endX, endY];
  if (!values.every(Number.isFinite)) return null;
  const deltaX = endX - startX;
  const deltaY = endY - startY;
  if (Math.abs(deltaX) < threshold || Math.abs(deltaX) <= Math.abs(deltaY)) return null;
  return deltaX < 0 ? 'next' : 'prev';
}

export function heroSlideDurationMs(slide) {
  const seconds = Number(slide?.duracao_segundos);
  return Number.isInteger(seconds) && seconds >= 2 && seconds <= 60
    ? seconds * 1000
    : DEFAULT_HERO_SLIDE_DURATION_SECONDS * 1000;
}

export function isHeroVideoSlide(slide) {
  return slide?.media_type === 'video';
}

export function canAutoplayHeroVideo({ saveData = false, reducedMotion = false } = {}) {
  return !saveData && !reducedMotion;
}

export function firstActiveHeroSlide(slides) {
  return [...(slides || [])]
    .filter(slide => slide?.ativo)
    .sort((left, right) => (left.ordem - right.ordem)
      || String(left.created_at || '').localeCompare(String(right.created_at || ''))
      || String(left.id || '').localeCompare(String(right.id || '')))[0] || null;
}

export function hasImageAsFirstActiveHeroSlide(slides) {
  const firstSlide = firstActiveHeroSlide(slides);
  return !firstSlide || !isHeroVideoSlide(firstSlide);
}

export function resolveHeroSlide(slide, at = new Date()) {
  if (!slide) return null;
  const resolved = interpolateCdiAge({
    titulo: slide.titulo || '',
    subtitulo: slide.subtitulo || '',
    cta_label: slide.cta_label || '',
  }, at);
  return {
    ...slide,
    ...resolved,
    titulo: slide.ocultar_conteudo ? '' : resolved.titulo,
    subtitulo: slide.ocultar_conteudo ? '' : resolved.subtitulo,
    cta_label: slide.ocultar_conteudo ? '' : resolved.cta_label,
    cta_url: slide.ocultar_conteudo ? '' : slide.cta_url,
    alt: resolved.titulo || 'CDI Premium — slide institucional',
  };
}
